import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class WarehouseService {
  getAllStockShopByManager(idUser) {
    return api.get(
      UtilsUrl.WarehousePosURL() + "/getAllStockShopByManager/" + idUser
    );
  }
}
export default new WarehouseService();
